<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/insert/replace/order/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xiangjiangenghuandanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>

          <el-form-item :label="$t('yuanxiangjianbianma')">
            <el-input v-model="yt.conditions.preInsertCode"></el-input>
          </el-form-item>

          <el-form-item :label="$t('ghxiangjianbianma')">
            <el-input v-model="yt.conditions.currentInsertCode"></el-input>
          </el-form-item>

          <el-form-item :label="$t('zhuangtai')">
            <yi_dictionary_select type="INSERT_REPLACE_STATUS" :ids.sync="yt.conditions.status"></yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="90 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.beginTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              v-if="scope.row.status === '0'"
              v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '镶件更换' } }"
              type="text"
              @click="
                yt.editObj = scope.row;
                yt.req('POST', '/web/insert/replace/order/update', null, null, '是否完成镶件更换');
              "
            >
              {{ $t('xiangjiangenghuan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
export default {
  name: 'web_molud_management_insert_replace_order',
  data() {
    return {
      begin: begin,
      end: end,
      columns: [
        {
          label: 'xiangjiangenghuandanhao',
          prop: 'no',
          width: 230
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 230
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 230
        },
        {
          label: 'mujubianma',
          prop: 'mould.code',
          width: 230
        },
        {
          label: 'yuanxiangjianbianma',
          prop: 'preInsert.code',
          width: 230
        },
        {
          label: 'yuanxiangjianmingcheng',
          prop: 'preInsert.name',
          width: 230
        },
        {
          label: 'ghxiangjianbianma',
          prop: 'currentInsert.code',
          width: 230
        },
        {
          label: 'ghxiangjianmingcheng',
          prop: 'currentInsert.name',
          width: 230
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'INSERT_REPLACE_STATUS'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'genghuancaozuoshijian',
          prop: 'replaceTime',
          type: 'time',
          width: 230
        },
        {
          label: 'caozuoren',
          prop: 'replaceByObject.nickname'
        },
        {
          label: 'caozuo',
          width: 100,
          type: 'slot',
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.beginTime = this.begin;
      this.yt.conditions.endTime = this.end;
      this.yt.conditions.orderBy = 'create_time desc';
      this.yt.get(1);
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions.pageSize = 10;
      this.yt.conditions.pageNum = 1;
      this.yt.conditions.beginTime = this.begin;
      this.yt.conditions.endTime = this.end;
      this.yt.conditions.orderBy = 'create_time desc';
      this.yt.get(1);
    }
  }
};
</script>

<style lang="less" scoped></style>
